import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

function ForgetPass() {
  const [state, setState] = React.useState({
    email: "",
    token: 0,
    password: null,
    confirm_password: null,
  });
  const [error, setError] = useState(null);
  const [successMessage, setsucessMessage] = useState(null);
  const [isTokenSent, setIsTokenSent] = useState(false);
  const [isTokenVerified, setIsTokenVerified] = useState(false);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const value = event.target.value;
    setState({
      ...state,
      [event.target.name]: value,
    });
  };

  const handleSentToken = (event) => {
    event.preventDefault();
    setError(null);

    axios
      .get(`${process.env.REACT_APP_API_URL}v1/user/password-recovery-token`, {
        params: { email: state.email },
      })
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          // console.log(response.data.message);
          setsucessMessage(response.data.message);
          setIsTokenSent(true);
          // navigate("/dashboard");
          // console.log(response);
        }
      })
      .catch((error) => {
        // console.log(error.response.data.errors);
        if (error.response.status === 422) {
          // console.log(error.response.data.errors);
          setError(error.response.data.message);
        } else if (error.response.status === 500) {
          setError("Something went wrong. Please try again later.");
        } else {
          setError("Something went wrong. Please try again later.");
        }
      });
  };

  const handleTokenVerification = (event) => {
    event.preventDefault();
    setError(null);
    setsucessMessage(null);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}v1/user/verify-password-recovery-token`,
        {
          params: { verification_token: state.token },
        }
      )
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          // console.log(response.data.message);
          setIsTokenVerified(true);
          setsucessMessage(response.data.message);
          // setState(response.data.message);
          // setIsTokenSent(true);
          // navigate("/dashboard");
          // console.log(response);
        }
      })
      .catch((error) => {
        // console.log(error.response.data.errors);
        if (error.response.status === 422) {
          // console.log(error.response.data.errors);
          setError(error.response.data.message);
        } else if (error.response.status === 500) {
          setError("Something went wrong. Please try again later.");
        } else {
          setError("Something went wrong. Please try again later.");
        }
      });
  };

  const handleResetPassword = (event) => {
    event.preventDefault();
    setError(null);
    setsucessMessage(null);

    axios
      .get(
        `${process.env.REACT_APP_API_URL}v1/user/reset-password-using-token`,
        {
          params: {
            password: state.password,
            confirm_password: state.confirm_password,
            verification_token: state.token,
          },
        }
      )
      .then((response) => {
        // console.log(response.data);
        if (response.status === 200) {
          // console.log(response.data.message);
          setsucessMessage(response.data.message);
          // setIsTokenSent(true);
          // navigate("/dashboard");
          // console.log(response);
        }
      })
      .catch((error) => {
        // console.log(error.response.data.errors);
        if (error.response.status === 422) {
          // console.log(error.response.data.errors);
          setError(error.response.data.message);
        } else if (error.response.status === 500) {
          setError("Something went wrong. Please try again later.");
        } else {
          setError("Something went wrong. Please try again later.");
        }
      });
  };

  const back = () => {
    // console.log("d");
    navigate(-1);
  };

  return (
    <>
      <div
        className="d-flex flex-column flex-root"
        style={{ marginTop: "140px" }}
      >
        <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            {/* <a href="../../demo1/dist/index.html" className="mb-12">
              <img
                alt="Logo"
                src="assets/media/logos/logo-1.svg"
                className="h-40px"
              />
            </a> */}
            {/* <h1 className="link-primary fw-bolder"> Lingonovel </h1> */}

            <div className="w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto">
              {isTokenSent === false ? (
                <form
                  className="form w-100"
                  method="GET"
                  onSubmit={handleSentToken}
                >
                  <div className="text-center mb-10">
                    <h1 className="text-dark mb-3">Forgot Password ?</h1>
                    <div className="text-gray-400 fw-bold fs-4">
                      Enter your email to reset your password.
                    </div>
                  </div>
                  <p style={{ color: "red", fontSize: "20px" }}>
                    {error ? error : ""}
                  </p>
                  <div className="fv-row mb-10">
                    <label className="form-label fw-bolder text-gray-900 fs-6">
                      Email
                    </label>
                    <input
                      className="form-control form-control-solid"
                      type="email"
                      placeholder=""
                      name="email"
                      id="email"
                      autoComplete="true"
                      onChange={handleChange}
                    />
                  </div>

                  <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                    <div className="mb-5">
                      <button
                        type="submit"
                        id="kt_password_reset_submit"
                        className="btn btn-lg btn-dark w-200px fw-bolder me-4"
                        // className="btn btn-lg btn-dark fw-bolder me-4"
                      >
                        Submit
                      </button>
                    </div>
                    <div className="m-0">
                      <Link
                        to={`#`}
                        onClick={back}
                        className="btn btn-lg btn-outline-dark m-0 fw-bolder"
                        style={{ border: "2px solid #000" }}
                      >
                        Cancel
                      </Link>
                    </div>
                  </div>
                </form>
              ) : (
                ""
              )}

              {isTokenSent === true && isTokenVerified === false ? (
                <>
                  <p style={{ color: "green", fontSize: "20px" }}>
                    {successMessage}
                  </p>

                  <form
                    className="form w-100"
                    method="GET"
                    onSubmit={handleTokenVerification}
                  >
                    <div className="text-center mb-10">
                      <h1 className="text-dark mb-3">Verify Token </h1>
                      <div className="text-gray-400 fw-bold fs-4">
                        Enter your Token Here...
                      </div>
                    </div>
                    <p style={{ color: "red", fontSize: "20px" }}>
                      {error ? error : ""}
                    </p>
                    <div className="fv-row mb-10">
                      <label className="form-label fw-bolder text-gray-900 fs-6">
                        Token
                      </label>
                      <input
                        className="form-control form-control-solid"
                        type="text"
                        placeholder=""
                        name="token"
                        id="token"
                        autoComplete="true"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                      <div className="mb-5">
                        <button
                          type="submit"
                          id="kt_password_reset_submit"
                          className="btn btn-lg btn-dark w-200px fw-bolder me-4"
                        >
                          Submit
                        </button>
                      </div>
                      <div className="m-0">
                        <Link
                          to={`#`}
                          onClick={back}
                          className="btn btn-lg btn-outline-dark m-0 fw-bolder"
                          style={{ border: "2px solid #000" }}
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                ""
              )}

              {isTokenVerified === true && isPasswordReset === false ? (
                <>
                  <p style={{ color: "green", fontSize: "20px" }}>
                    {successMessage}
                  </p>

                  <form
                    className="form w-100"
                    method="GET"
                    onSubmit={handleResetPassword}
                  >
                    <div className="text-center mb-10">
                      <h1 className="text-dark mb-3"> Password Reset </h1>
                    </div>
                    <p style={{ color: "red", fontSize: "20px" }}>
                      {error ? error : ""}
                    </p>
                    <div className="fv-row mb-10">
                      <label className="form-label fw-bolder text-gray-900 fs-6">
                        New Password
                      </label>
                      <input
                        className="form-control form-control-solid"
                        type="password"
                        placeholder=""
                        name="password"
                        id="password"
                        autoComplete="true"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="fv-row mb-10">
                      <label className="form-label fw-bolder text-gray-900 fs-6">
                        Confirm Password
                      </label>
                      <input
                        className="form-control form-control-solid"
                        type="password"
                        placeholder=""
                        name="confirm_password"
                        id="confirm_pasword"
                        autoComplete="true"
                        onChange={handleChange}
                      />
                    </div>

                    <div className="d-flex flex-wrap justify-content-center pb-lg-0">
                      <div className="mb-5">
                        <button
                          type="submit"
                          id="kt_password_reset_submit"
                          className="btn btn-lg btn-dark w-200px fw-bolder me-4"
                        >
                          Submit
                        </button>
                      </div>
                      <div className="m-0">
                        <Link
                          to={`#`}
                          onClick={back}
                          className="btn btn-lg btn-outline-dark m-0 fw-bolder m-0"
                          style={{ border: "2px solid #000" }}
                        >
                          Cancel
                        </Link>
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          {/* <div className="d-flex flex-center flex-column-auto p-10">
            <div className="d-flex align-items-center fw-bold fs-6">
              <a
                href="https://keenthemes.com"
                className="text-muted text-hover-primary px-2"
              >
                About
              </a>
              <a
                href="mailto:support@keenthemes.com"
                className="text-muted text-hover-primary px-2"
              >
                Contact
              </a>
              <a
                href="https://1.envato.market/EA4JP"
                className="text-muted text-hover-primary px-2"
              >
                Contact Us
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default ForgetPass;
